import { useQuery } from '@tanstack/react-query';
import { fetchAppPopupConfig } from '@/features/appStatus/api/appStatusApi';
import { queryKeys } from '@/shared/lib/query/queryKeys';

export function useAppStatusQuery() {
  return useQuery({
    queryKey: queryKeys.appStatus.popupConfig(),
    queryFn: fetchAppPopupConfig,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
